import { AxiosResponse } from 'axios';
import axiosInstance from './axios';

// ─── A: Calyx project type mapping ─────────────────────────────────────

export const getMitigationTypeMappings = async (): Promise<any> => {
  try {
    const response: AxiosResponse = await axiosInstance.get('/mitigation_type_mapping');
    return response.data;
  } catch (error: any) {
    const errorMessage = error?.response?.data?.message || 'internal service error';
    throw new Error(`Error fetching mitigation type mappings: ${errorMessage}`);
  }
};

export const createMitigationTypeMapping = async (data: any): Promise<any> => {
  try {
    const response: AxiosResponse = await axiosInstance.post('/mitigation_type_mapping', data);
    return response.data;
  } catch (error: any) {
    const errorMessage = error?.response?.data?.message || 'internal service error';
    throw new Error(`Error creating mitigation type mapping: ${errorMessage}`);
  }
};

export const updateMitigationTypeMapping = async (data: any): Promise<any> => {
  try {
    const response: AxiosResponse = await axiosInstance.put('/mitigation_type_mapping', data);
    return response.data;
  } catch (error: any) {
    const errorMessage = error?.response?.data?.message || 'internal service error';
    throw new Error(`Error updating mitigation type mapping: ${errorMessage}`);
  }
};

export const deleteMitigationTypeMapping = async (id: string): Promise<any> => {
  try {
    const response: AxiosResponse = await axiosInstance.delete(`/mitigation_type_mapping/${id}`);
    return response.data;
  } catch (error: any) {
    const errorMessage = error?.response?.data?.message || 'internal service error';
    throw new Error(`Error deleting mitigation type mapping: ${errorMessage}`);
  }
};

// ─── B: Registry methodology mapping ───────────────────────────────────

export const getMitigationTypeMethodologyMappings = async (): Promise<any> => {
  try {
    const response: AxiosResponse = await axiosInstance.get('/mitigation_type_mapping/methodology');
    return response.data;
  } catch (error: any) {
    const errorMessage = error?.response?.data?.message || 'internal service error';
    throw new Error(`Error fetching mitigation type methodology mappings: ${errorMessage}`);
  }
};

export const createMitigationTypeMethodologyMapping = async (data: any): Promise<any> => {
  try {
    const response: AxiosResponse = await axiosInstance.post('/mitigation_type_mapping/methodology', data);
    return response.data;
  } catch (error: any) {
    const errorMessage = error?.response?.data?.message || 'internal service error';
    throw new Error(`Error creating mitigation type methodology mapping: ${errorMessage}`);
  }
};

export const updateMitigationTypeMethodologyMapping = async (id: string, data: any): Promise<any> => {
  try {
    const response: AxiosResponse = await axiosInstance.put(`/mitigation_type_mapping/methodology/${id}`, data);
    return response.data;
  } catch (error: any) {
    const errorMessage = error?.response?.data?.message || 'internal service error';
    throw new Error(`Error updating mitigation type methodology mapping: ${errorMessage}`);
  }
};

export const deleteMitigationTypeMethodologyMapping = async (id: string): Promise<any> => {
  try {
    const response: AxiosResponse = await axiosInstance.delete(`/mitigation_type_mapping/methodology/${id}`);
    return response.data;
  } catch (error: any) {
    const errorMessage = error?.response?.data?.message || 'internal service error';
    throw new Error(`Error deleting mitigation type methodology mapping: ${errorMessage}`);
  }
};

// ─── C: Project ID override mapping ────────────────────────────────────

export const getMitigationTypeProjectIdMappings = async (): Promise<any> => {
  try {
    const response: AxiosResponse = await axiosInstance.get('/mitigation_type_mapping/project_id');
    return response.data;
  } catch (error: any) {
    const errorMessage = error?.response?.data?.message || 'internal service error';
    throw new Error(`Error fetching mitigation type project ID mappings: ${errorMessage}`);
  }
};

export const createMitigationTypeProjectIdMapping = async (data: any): Promise<any> => {
  try {
    const response: AxiosResponse = await axiosInstance.post('/mitigation_type_mapping/project_id', data);
    return response.data;
  } catch (error: any) {
    const errorMessage = error?.response?.data?.message || 'internal service error';
    throw new Error(`Error creating mitigation type project ID mapping: ${errorMessage}`);
  }
};

export const updateMitigationTypeProjectIdMapping = async (id: string, data: any): Promise<any> => {
  try {
    const response: AxiosResponse = await axiosInstance.put(`/mitigation_type_mapping/project_id/${id}`, data);
    return response.data;
  } catch (error: any) {
    const errorMessage = error?.response?.data?.message || 'internal service error';
    throw new Error(`Error updating mitigation type project ID mapping: ${errorMessage}`);
  }
};

export const deleteMitigationTypeProjectIdMapping = async (id: string): Promise<any> => {
  try {
    const response: AxiosResponse = await axiosInstance.delete(`/mitigation_type_mapping/project_id/${id}`);
    return response.data;
  } catch (error: any) {
    const errorMessage = error?.response?.data?.message || 'internal service error';
    throw new Error(`Error deleting mitigation type project ID mapping: ${errorMessage}`);
  }
};
